import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { OrdenCompraService } from 'src/app/services/orden-compra.service';

@Component({
  selector: 'app-comentario-orden-compra',
  templateUrl: './comentario-orden-compra.component.html',
  styleUrls: ['./comentario-orden-compra.component.scss'],
})
export class ComentarioOrdenCompraComponent implements OnInit {
  registerForm: UntypedFormGroup;
  public dataInput: any;
  public tituloTxt = 'Comentario';
  constructor(
    public ordenCompraSvc: OrdenCompraService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ComentarioOrdenCompraComponent>
  ) {}

  ngOnInit(): void {
     this.inicarFormulario();
    this.ordenCompraSvc
      .getComentario({
        ordenCompraId: this.data.ordenCompraId,
        usuarioId: this.data.usuarioId,
      })
      .subscribe((result) => {
        this.dataInput = result;
       this.llenarDatos();
      });
  }

  inicarFormulario() {
    this.registerForm = new UntypedFormGroup({
      ordenCompraId: new UntypedFormControl('', Validators.required),
      usuarioId: new UntypedFormControl('', Validators.required),
      comentario: new UntypedFormControl(''),
    });

  }

  llenarDatos(){
    this.registerForm
      .get('ordenCompraId')
      ?.setValue(this.dataInput.ordenCompraId);
    this.registerForm.get('usuarioId')?.setValue(this.dataInput.usuarioId);
    this.registerForm.get('comentario')?.setValue(this.dataInput.comentario);
  }

  guardar() {
    console.log(this.registerForm.value);

    this.ordenCompraSvc
      .setComentario(this.registerForm.value)
      .subscribe((res) => {
        console.log('resultado: ', res);
        if (res) {
          this.alertify.success('Comentario actualizado');
          this.dialogRef.close();
        } else {
          this.alertify.error('El comentario no se ha podido actualizar');
        }
      });
  }
}
